export const ONBOARDING_INIT = 'ONBOARDING_INIT';
export const GUEST_ONBOARDING_INIT = 'GUEST_ONBOARDING_INIT';

export const ADD_QUEUED_PHOTO = 'ADD_QUEUED_PHOTO';
export const DELETE_ONBOARDING = 'EXIT_ONBOARDING';
export const DELETE_ONBOARDING_SUCCESS = 'DELETE_ONBOARDING_SUCCESS';
export const CLEAR_QUEUED_PHOTOS = 'CLEAR_QUEUED_PHOTOS';
export const COMPLETE_ONBOARDING = 'COMPLETE_ONBOARDING';
export const COMPLETE_ONBOARDING_SUCCESS = 'COMPLETE_ONBOARDING_SUCCESS';
export const COMPLETE_ONBOARDING_ERROR = 'COMPLETE_ONBOARDING_ERROR';

// This is used for AV post-onboarding modal
export const RESET_ONBOARDING_COMPLETION_STATUS = 'RESET_ONBOARDING_COMPLETION_STATUS';

export const FETCH_ONBOARDING_FIELDS = 'FETCH_ONBOARDING_FIELDS';
export const FETCH_ONBOARDING_FIELDS_REQUEST = 'FETCH_ONBOARDING_FIELDS_REQUEST';
export const FETCH_ONBOARDING_FIELDS_SUCCESS = 'FETCH_ONBOARDING_FIELDS_SUCCESS';
export const FETCH_ONBOARDING_FIELDS_ERROR = 'FETCH_ONBOARDING_FIELDS_ERROR';
export const REMOVE_QUEUED_PHOTO = 'REMOVE_QUEUED_PHOTO';
export const SET_ONBOARDING_STEP = 'SET_ONBOARDING_STEP';
export const SET_ONBOARDING_STEPS = 'SET_ONBOARDING_STEPS';

export const SET_ONBOARDING_ERRORS = 'SET_ONBOARDING_ERRORS';
export const SET_ONBOARDING_FIELDS = 'SET_ONBOARDING_FIELDS';

export const UPDATE_ONBOARDING_FIELDS = 'UPDATE_ONBOARDING_FIELDS';
export const UPDATE_ONBOARDING_FIELDS_REQUEST = 'UPDATE_ONBOARDING_FIELDS_REQUEST';
export const UPDATE_ONBOARDING_FIELDS_SUCCESS = 'UPDATE_ONBOARDING_FIELDS_SUCCESS';
export const UPDATE_ONBOARDING_FIELDS_ERROR = 'UPDATE_ONBOARDING_FIELDS_ERROR';
export const UPDATE_QUEUED_PHOTOS_ORDER = 'UPDATE_QUEUED_PHOTOS_ORDER';

export const ONBOARDING_SPARKS = 'ONBOARDING_SPARKS';

export const ONBOARDING_SUBMIT_ACTION = 'submit';
export const ONBOARDING_SKIP_ACTION = 'skip';

// auth attribution sources
export const MATCH_MAKER_ATTRIBUTION_SOURCE = 'matchmaker';
